// sensor types components
const SensorTypes = () => import("Modules/configuration/sensor_types/views/SensorTypes");

export default {
    children: [
        {
            path: "configuration/sensor_types",
            name: "sensor_types",
            component: SensorTypes,
            meta: {
                requiresAuth: true,
                title: "lang.sensor_types",
                restrict_by_login_type: ["employee", "customer_support", "administrator", "developer"],
                restrict_by_permission: ["configuration.read"],
            },
        },
    ],
};
